import { render, staticRenderFns } from "./AddCompanyTrustedPartner.vue?vue&type=template&id=b0af6f7e&"
import script from "./AddCompanyTrustedPartner.vue?vue&type=script&lang=js&"
export * from "./AddCompanyTrustedPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports